import { AudioFileExtension } from '../enums/AudioFileExtension'

export const audioFileMimeTypes: { [key in AudioFileExtension]: string } = {
  [AudioFileExtension.Mp3]: 'audio/mpeg',
  [AudioFileExtension.Wav]: 'audio/wav',
  [AudioFileExtension.Ogg]: 'audio/ogg',
  [AudioFileExtension.Mp4]: 'audio/mp4',
  [AudioFileExtension.Flac]: 'audio/flac',
  [AudioFileExtension.Aac]: 'audio/aac',
}
